import * as React from "react";
import {DataGrid} from "@mui/x-data-grid";
import {Button, Card, CardContent, useMediaQuery, Snackbar, Alert} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {POST} from "APIclient";
import properties from "constants/ApplicationConstants";

const cronJobLinks = [
  {id: 1, name: "Send Birthday Mail", url: `admin/cron/bday-mail`},
  {id: 2, name: "Send Probation Remainder Mail", url: `admin/cron/Probation-remainder`},
  {id: 3, name: "Send Auto Leave Approval Mail", url: `admin/cron/auto-leave-approve-mail`},
  {
    id: 4,
    name: "Send Biometric Leaves Deduction Mail",
    url: `admin/cron/send-biometric-leaves-deduction-mail`
  },
  {
    id: 5,
    name: "Assign leave to employees for every year",
    url: `admin/cron/assign-leaves`
  },
  {
    id: 6,
    name: "Assign Leave After Completion of 5 Years",
    url: "admin/cron/assign-leave-after-completionOf-5Years"
  },
  {id: 7, name: "Send Exit Notification", url: `admin/cron/send-exit-formalities-reminder`},
  {id: 8, name: "Send Appraisal Reminder Email To Employee", url: `kra-reminder-employee`},
  {id: 9, name: "Notify Upcoming Employee Exit", url: `exit-notification`},
  {id: 10, name: "Update Roster Date and Reference", url: `update-roster`}
];

export default function CronJobLinks() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackColor, setSnackColor] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");

  const handleClose = () => {
    setSnackOpen(false);
  };

  const handleRunJob = async url => {
    try {
      const response = await POST(url);
      if (response?.status === 200) {
        setSnackMessage("Job executed successfully!");
        setSnackColor("success");
        setSnackOpen(true);
      } else {
        setSnackMessage("Failed to run the job.");
        setSnackColor("error");
        setSnackOpen(true);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Error running the job.";
      setSnackColor("error");
      setSnackMessage(errorMsg);
      setSnackOpen(true);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "#",
      width: 60
    },
    {
      field: "name",
      headerName: "Link Name",
      flex: 1,
      minWidth: 150
    },
    {
      field: "action",
      headerName: "Action",
      width: 160,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: params => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<PlayArrowIcon />}
          onClick={() => handleRunJob(params.row.url)}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: "500",
            color: "#fff",
            background: properties.colors.bgcolorbluethem
          }}
        >
          Run
        </Button>
      )
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox p={isMobile ? 1 : 1}>
        <Card>
          <CardContent>
            <MDTypography
              variant="h3"
              gutterBottom
              sx={{
                color: "textPrimary",
                fontFamily: properties.fontFamily,
                fontWeight: "bold"
              }}
              fontSize={isMobile ? "1.2rem" : "1.2rem"}
            >
              Cron Job Links
            </MDTypography>
            <div style={{width: "100%", overflowX: "auto"}}>
              <div style={{height: 600, minWidth: isMobile ? 500 : "100%"}}>
                <DataGrid
                  rows={cronJobLinks}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  disableSelectionOnClick
                  sx={{
                    fontFamily: properties.fontFamily,
                    fontSize: "12px",
                    mt: 1,
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f5f5f5",
                      fontWeight: "bold"
                    },
                    fontSize: isMobile ? "0.85rem" : "1rem"
                  }}
                />
              </div>
            </div>
          </CardContent>
        </Card>
        <Snackbar
          open={snackOpen}
          anchorOrigin={{vertical: "top", horizontal: "right"}}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            close={handleClose}
            severity={snackColor == "success" ? "success" : "error"}
            variant="filled"
            sx={{width: "100%", color: "#fff"}}
          >
            {snackMessage}
          </Alert>
        </Snackbar>
      </MDBox>
    </DashboardLayout>
  );
}
